import { LOBBY_COPY } from "@/content/lobby"
import { ROUND_COPY } from "@/content/rounds"
import { activeRounds } from "@/store/selectors"
import type { SessionConfig } from "@/types"
import styles from "@/styles/pages/Lobby.module.css"

/*
 * The run sheet, for everyone who is not driving.
 *
 * The room cannot change any of this, which is exactly why showing it is worth
 * the space: "how long is this going to take" is the question every workshop
 * participant actually has, and answering it up front buys the facilitator the
 * rest of the session.
 *
 * Built from `activeRounds`, so a session with the pains round or the deep dive
 * switched off shows a shorter plan rather than a plan with gaps. That makes it
 * the one place a guest can see the shape of the session they are in.
 */

interface LobbyPlanProps {
  config: SessionConfig
  customerName: string
}

export default function LobbyPlan({ config, customerName }: LobbyPlanProps) {
  const rounds = activeRounds(config)
  const total = rounds.reduce((sum, round) => sum + (config.roundDurations[round] ?? 0), 0)

  return (
    <section className={styles.plan}>
      <p className={styles.planLabel}>{LOBBY_COPY.planLabel}</p>
      <p className={styles.planCustomer}>{customerName}</p>

      <ul className={styles.planRows}>
        {rounds.map((round) => (
          <li key={round} className={styles.planRow}>
            <span className={styles.planRowText}>
              <span className={styles.planRowName}>{ROUND_COPY[round].label}</span>
              <span className={styles.planRowHint}>{ROUND_COPY[round].objective}</span>
            </span>
            <span className={styles.planMins}>
              {LOBBY_COPY.planMinutes(config.roundDurations[round] ?? 0)}
            </span>
          </li>
        ))}
      </ul>

      <p className={styles.planTotal}>
        <span>{LOBBY_COPY.planTotal}</span>
        <span>{LOBBY_COPY.planTotalMinutes(total)}</span>
      </p>
    </section>
  )
}
